import { colors, screen } from 'components/styles/variables';

export default `  
  .vehicle-card {
    width: 735px;
    max-height: 338px;
    border-radius: 16px;
    border: 1px solid ${colors.G2};
    background: ${colors.WHITE};
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.08);
    margin: 24px 0;
  }
  .header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-bottom: 1px solid ${colors.G2};
    padding: 8px 16px 4px 16px;
    border-radius: 16px 16px 0 0;
  }
  .header.available {
    background: ${colors.ALG2};
    color: ${colors.WHITE};
  }
  .header.unavailable {
    background: ${colors.G3};
    color: ${colors.WHITE};
  }
  span.available {
    color: ${colors.ALG2};
  }
  .status {
    font-size: 14px;
  }
  .status,
  .date {
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.2px;
  }
  .content {
    display: flex;
    flex-direction: column;
    padding: 16px;
  }
  .flex {
    display: flex;
    flex-direction: column;
  }
  .status-text {
    color: ${colors.G3};
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
  }
  .status-text.price-accepted {
    color: ${colors.ALG2};
  }
  .status-text.price-rejected {
    color: ${colors.ALR1};
  }
  .vehicle-image {
    border-radius: 8px;
    height: 153px;
    width: 256px;
    margin-bottom: 16px;
    object-fit: cover;
  }
  .vehicle-price {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
  }
  .vehicle-price.accepted-price {
    justify-content: normal;
  }
  span.accepted-price-original {
    text-decoration: line-through;
    margin-right: 5px;
  }
  span.accepted-price {
    color: ${colors.ALG2};
  }
  .requested-price {
    color: ${colors.ALG2};
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.2px;
  }
  .vehicle-price,
  .vehicle-mileage {
    margin-top: 6px;
  }
  .vehicle-name,
  .vehicle-price,
  .dealer-name {
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0.2px;
  }
  .vehicle-mileage,
  .dealer-address-1,
  .dealer-address-2 {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.2px;
  }
  .vehicle-availability,
  .vehicle-current-price {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.2px;
    border-bottom: 1px solid ${colors.G1};
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
  }
  .vehicle-availability {
    border-top: 1px solid ${colors.G1};
  }
  .vehicle-current-price {
    margin-bottom: 16px;
  }
  .remove-button {
    display: flex;
    width: 100px;
    height: 34px;
    padding: 12px 32px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    border: 1px solid ${colors.BLACK};
    background: ${colors.WHITE};
    font-weight: 600;
    font-size: 14px;
    margin: 5px 0;
  }
  .contact-icon {
    margin-right: 4px;
  }
  .dealer-phone,
  .dealer-directions,
  .dealer-website {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.2px;
    padding-top: 3px;
  }
  .dealer-directions,
  .dealer-website:hover {
    cursor: pointer;
  }
  .dealer-contact {
    display: flex;
    gap: 25px;
  }
  .dealer-address-container {
    display: flex;
    gap: 3px;
  }
  .dealer-name {
    margin-bottom: 2px;
  }
  .date {
    font-size: 12px;
  }

  @media (min-width: 320px) {
    .vehicle-card {
      width: 288px;
      max-height: none;
    }
  }
  @media (min-width: 375px) {
    .vehicle-card {
      width: 343px;
    }
    .vehicle-image {
      height: 185px;
      width: 312px;
    }
  }
  @media (min-width: 440px) {
    .vehicle-card {
      width: 409px;
    }
    .vehicle-image {
      height: 223px;
      width: 376px;
    }
  }
  @media (min-width: ${screen.smMin}) {
    .header {
      flex-direction: row;
      padding: 7px 24px;
    }
    .content {
      flex-direction: row;
      padding: 24px 24px 40px 24px;
    }
    .vehicle-card {
      width: 735px;
      max-height: 735px;
    }
    .flex {
      flex-direction: row;
    }
    .vehicle-image {
      margin-right: 24px;
      margin-bottom: 0;
      height: 104px;
      width: 138px;
    }
    .vehicle-information {
      border-right: 1px solid ${colors.G2};
      padding-right: 28px;
    }
    .vehicle-info {
      width: 256px;
    }
    .vehicle-price {
      margin-bottom: 20px;
    }
    .status-text.price-confirmed {
      color: ${colors.BLACK};
    }
    .vehicle-current-price {
      margin-bottom: 30px;
    }
    .dealer-information {
      margin-left: 28px;
    }
    .dealer-contact {
      margin-top: 16px;
      display: block;
      gap: 0;
    }
    .dealer-phone,
    .dealer-directions,
    .dealer-website {
      padding: 6px 0;
    }
    .dealer-address-container {
      display: block;
      gap: 0;
    }
    .dealer-name {
      margin-bottom: 0;
    }
    .status {
      font-size: 16px;
    }
    .date {
      font-size: 14px;
    }
    .remove-button {
      margin: -10px 0 0 0;
    }
  }
`;
